import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var People = function People(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [/*#__PURE__*/_jsxs("mask", {
      id: "people-mask",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 1,
      y: 1,
      width: 18,
      height: 18,
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 1.667A4.167 4.167 0 1 0 7.5 10a4.167 4.167 0 0 0 0-8.333ZM5 5.833a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z",
        fill: color
      }), /*#__PURE__*/_jsx("path", {
        d: "M4.065 14.066a2.5 2.5 0 0 1 1.768-.733h3.333a2.5 2.5 0 0 1 2.5 2.5V17.5a.833.833 0 0 0 1.667 0v-1.667a4.167 4.167 0 0 0-4.167-4.166H5.833a4.167 4.167 0 0 0-4.167 4.166V17.5a.833.833 0 0 0 1.667 0v-1.667a2.5 2.5 0 0 1 .732-1.767ZM12.525 2.402a.833.833 0 0 1 1.014-.6 4.167 4.167 0 0 1 0 8.072.833.833 0 1 1-.413-1.615 2.5 2.5 0 0 0 0-4.843.833.833 0 0 1-.6-1.014ZM15.208 11.818a.833.833 0 1 0-.417 1.614 2.5 2.5 0 0 1 1.875 2.404V17.5a.833.833 0 0 0 1.667 0V15.83a4.167 4.167 0 0 0-3.125-4.01Z",
        fill: color
      })]
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#people-mask)",
      children: /*#__PURE__*/_jsx("path", {
        fill: color,
        d: "M0 0h20v20H0z"
      })
    })]
  });
};
export default People;